import { useLayoutEffect } from 'react';
import { removeGlobalToolbarPlaceholder, removeVerticalNavPlaceholder } from '../utils/globalToolbarUtils';
const useRemoveNavPlaceholder = ({
  placeholderType,
  shouldRemovePlaceholder = true
}) => {
  useLayoutEffect(() => {
    if (!shouldRemovePlaceholder) return;
    if (placeholderType === 'global-toolbar') {
      removeGlobalToolbarPlaceholder();
    }
    if (placeholderType === 'vertical-nav') {
      removeVerticalNavPlaceholder();
    }
  }, [placeholderType, shouldRemovePlaceholder]);
};
export default useRemoveNavPlaceholder;